/**
 * Turns a destination URL into the host a Google ad shows the reader, which is
 * never the full link. Shared because more than one preview family needs it:
 * the RSA search result and the YouTube in-stream end card.
 */
export class UrlDisplayHelper {
  /** Shown when the author has not filled the destination URL in yet. */
  static readonly PLACEHOLDER_HOST = 'www.example.com';

  /** Parse a hostname out of the destination URL, with graceful fallbacks. */
  static hostOf(rawUrl: string): string {
    const url = rawUrl.trim();
    if (!url) {
      return this.PLACEHOLDER_HOST;
    }
    try {
      const withScheme = /^https?:\/\//i.test(url) ? url : `https://${url}`;
      return new URL(withScheme).hostname;
    } catch {
      // Fall back to the raw text up to the first slash if it is not parseable.
      return url.replace(/^https?:\/\//i, '').split('/')[0] ?? url;
    }
  }
}
